import getConfig from './getConfig';

export const isNotProduction = (): boolean => {
  const { publicRuntimeConfig } = getConfig();
  const memriseEnv = publicRuntimeConfig.MEMRISE_ENV;
  return memriseEnv === 'testing' || memriseEnv === 'development';
};
